import MaterialTable, { MTableCell } from '@material-table/core'
import { Box, Collapse, Divider, Grid, IconButton, Menu, MenuItem, Typography, Button } from '@material-ui/core'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import { ExpandLessOutlined, ExpandMoreOutlined } from '@material-ui/icons'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { capitalize } from 'lodash-es'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { getVisitsByFacilityId } from '../../actions/visits/visits.actions'
import { updateFacilityIndividual } from '../../actions/facilities/facilities.actions'
import { movePets } from '../../actions/pets/pets.actions'
import { getPetAge, getPetSizeV1 } from '../../services/helpers'
import { table } from '../../services/theme'
import { api } from '../../services/api'
import {
	capitilizeMultipleWords,
	DEFAULT_EMPTY_VALUE,
	getSpecificAreas,
	PLAY_STYLES_ARRAY,
	PLAYGROUP_MASKED_STATUS,
	PLAYGROUP_TYPE_BEST_FIT_SIZES_ARRAY,
	PLAYGROUP_TYPE_SIZES_ARRAY,
} from '../../utils'
import { StatBox } from '../Button/StatBox'
import DeleteConfirmation from '../Dialogs/DeleteConfirmation'
import { PlaygroupsToolbar } from './Toolbars/Playgroups/PlaygroupsToolbar'

const useStyles = makeStyles((theme) => ({
	header: {
		width: '100%',
		padding: 15,
		paddingLeft: 0,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		'& div': {
			fontSize: '21px',
			lineHeight: '30px',
			fontWeight: '600',
			fontFamily: 'Nunito',
			marginRight: 19
		}
	},
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '0px 12px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	datePickerContainer: {
		paddingLeft: 24,
		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
		// position: "relative",
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		// position: "absolute",
		// top: 0,
		height: 38,
		marginLeft: 16,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	tables: {
		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 10,
		paddingRight: 15,
		paddingLeft: 0
	},
	playStyles: {
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		padding: 10,
		paddingRight: 15,
		paddingLeft: 0
	},
	colTitle: {
		fontFamily: 'Nunito',
		fontSize: 14,
		lineHeight: '19px',
		fontWeight: '800',
		letterSpacing: 0.75,
		color: '#5F38BE',
		marginBottom: 5,
		'& i.fa-exclamation-circle': {
			color: '#DB4A42',
			fontSize: '15px',
			marginLeft: 12
			// position: 'absolute',
			// top: '22px',
			// right: '3%'
		}
	},
	colLabel: {
		width: '50%',
		fontFamily: 'Nunito',
		fontSize: 12,
		lineHeight: '18px',
		fontWeight: '800',
		color: '#1A1A35',
		marginRight: '5px',
		display: 'flex',
		justifyContent: 'center'
	},
	colValue: {
		width: '50%',
		fontFamily: 'Nunito',
		fontSize: '22px',
		fontWeight: '800',
		color: '#5F38BE',
		lineHeight: '30px',
		textAlign: 'center'
	},
	groupCol: {
		// width: '20%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		padding: '5px'
		// '& p': {
		// 	margin: 0
		// },
		// '& .change': {
		// 	fontFamily: 'Nunito',
		// 	fontSize: 14,
		// 	fontWeight: '600',
		// 	color: '#6B4AD6',
		// 	lineHeight: '23px',
		// 	cursor: 'pointer'
		// },
		// '& .char': {
		// 	fontFamily: 'Nunito',
		// 	fontSize: 14,
		// 	fontWeight: '600',
		// 	color: '#6B4AD6',
		// 	lineHeight: '23px',
		// 	cursor: 'pointer',
		// 	backgroundColor: 'rgba(107, 74, 214, 0.1)',
		// 	padding: 4,
		// 	borderRadius: 6,
		// 	marginRight: 4,
		// 	marginBottom: 4
		// }
	},
	columnNoWidth: {
		display: 'flex',
		// flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '5px',
		height: '106px'
	},
	groupColHorizontal: {
		// width: '16%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		padding: '5px',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	timeTable: {
		width: '24%',
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		padding: 14,
		justifyContent: 'flex-start',
		'& h4': {
			marginTop: 0,
			marginBottom: 5,
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	},
	timeRowLight: {
		backgroundColor: '#F9F9F9',
		borderRadius: 6
	},
	chipRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	spacer: {
		margin: '5px 16px 5px 0px',
		width: '24px',
		position: 'relative',
		'&:before': {
			content: "''",
			position: 'absolute',
			height: '1px',
			width: '100%',
			top: 'calc(50% - 1px)',
			left: 0,
			backgroundColor: '#F3F3F3'
		}
	},
	group: {
		width: '100%',
		minWidth: '1000px',
		padding: '0px 23px',
		boxShadow: '0px 2px 10px rgba(26, 26, 53, 0.1)',
		backgroundColor: '#FFF',
		borderRadius: 6,
		marginBottom: 28
		// cursor: "pointer"
	},
	innerGroup: ({ isDeactivated, deactivatedColor }) => {
		return {
			width: '100%',
			margin: '41px 0px 33px 0px',
			paddingLeft: '18px',
			backgroundColor: '#FFF',
			borderRadius: 6,
			'& span,p': {
				...deactivatedColor
			}
			// cursor: "pointer"
		}
	},
	topRow: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		cursor: 'default'
		// marginBottom: 10
	},
	groupBody: {
		width: '90%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		alignItems: 'flex-start',
		// padding: 15,
		// backgroundColor: '#F9F9F9',
		borderRadius: 6
	},
	groupBodyCentered: {
		width: '95%',
		padding: '0px',
		display: 'flex',
		flexDirection: 'row',
		// justifyContent: 'space-evenly',
		alignItems: 'center',
		// padding: 15,
		// backgroundColor: '#F9F9F9',
		borderRadius: 6
	},
	capacity: {
		fontFamily: 'Nunito',
		fontSize: 24,
		fontWeight: '800',
		color: '#1A1A35',
		margin: '5px 0px 5px 0px'
	},
	groupsBlocks: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	bestFit: {
		width: '25%',
		minHeight: 200,
		// height: 200,
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		marginTop: 10
	},
	bestFitTitle: {
		fontFamily: 'Nunito',
		fontSize: 26,
		fontWeight: '800',
		color: '#1A1A35',
		margin: 24,
		marginBottom: 8
	},
	playBlock: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: '600',
		color: '#1A1A35',
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginTop: 17
	},
	playName: {
		// marginRight: 20,
		width: '10%',
		fontFamily: 'Nunito',
		fontSize: 14,
		fontWeight: '600',
		color: '#1A1A35',
		lineHeight: '19px'
	},
	kennelBlock: {
		width: '70%',
		fontFamily: 'Nunito',
		fontSize: '14px',
		lineHeight: '19px',
		fontWeight: '600',
		color: '#777679',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	change: {
		width: '20%',
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: '600',
		color: '#6B4AD6',
		lineHeight: '19px',
		cursor: 'pointer'
	},
	characteristics: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start'
	},
	staff: {},
	staffRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		'& div': {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-start'
		},
		'& h5': {
			fontFamily: 'Nunito',
			fontSize: 16,
			lineHeight: '22px',
			fontWeight: '600',
			color: '#1A1A35',
			margin: 0,
			marginRight: '10px'
		},
		'& span': {
			fontFamily: 'Nunito',
			fontSize: 16,
			lineHeight: '22px',
			fontWeight: '600',
			color: '#777679',
			marginRight: '10px'
		}
	},
	chip: {
		background: 'rgba(107, 74, 214, 0.1)',
		backgroundColor: 'rgba(107, 74, 214, 0.1)',
		color: theme.palette.primary.main,
		marginRight: '4px',
		marginBottom: '4px'
	},
	timeBox: {
		width: '100%',
		paddingLeft: 24,
		paddingRight: 24
	},
	timeRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		// marginLeft: 24,
		// marginRight: 24,
		marginBottom: 5,
		padding: 4,
		width: '100%',
		'& span': {
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 14
		},
		'&:nth-child(odd)': {
			backgroundColor: '#F9F9F9',
			borderRadius: 6
		}
	},
	dot: {
		height: '9px',
		width: '9px',
		borderRadius: '50%',
		display: 'inline-block',
		marginRight: '5px'
	},
	unassignedBox: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		height: 161,
		overflowY: 'scroll',
		border: '1px solid #D0CFD2',
		borderRadius: 6,
		width: '100%',
		marginTop: 16,
		marginBottom: 12
	}
}))

export const PlaygroupsTable = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const params = useParams()
	const dispatch = useDispatch()

	const facility = useSelector((state) => state.specific.facilities.selected)

	const [term, setTerm] = useState('')
	const [formattedDate, setFormattedDate] = useState(moment().format('YYYY-MM-DD'))



	let {
		visits,
		date,
		setDate,
		changeDate,
		playgroup_types,
		playgroups,
		areas,
		setGroup,
		unassigned_pets = 0,
		daytime_pets = 0,
		need_group_pets = [0, 0],
		setDialogShown,
		setIsShown,
		staff,
		pets,
		setPlayShown,
		kennels = [],
		kennel_blocks = [],
		openMenu,
		openMenus,
		loading
	} = props

	const isBeforeTwoDays = moment(date).isBefore(moment().add(1, 'day').endOf('day'))
	let environment = process.env.REACT_APP_ENV
	const active_groups = playgroups
		.map((g) => {
			const type = playgroup_types.find((t) => t._id === g.playgroup_type_id)
			let counted_group_type
			if (!type) {
				counted_group_type = true
			} else {
				counted_group_type = type.counted_group_type ? true : false
			}
			return {
				...g,
				counted_group_type
			}
		})
		.filter((g) => g.status === 'in use' && g.counted_group_type).length

	useEffect(() => {
		if (date) setFormattedDate(moment(date).format('YYYY-MM-DD'))
	}, [date])

	const autoAssign = async () => {
		try {

			dispatch({ type: 'GET_VISITS' })
			const { data } = await api.post(`/facilities/autoAssignPlaygroups/123?date=${moment(date).format('YYYY-MM-DD')}&facilityId=${facility._id}`)
			console.log('data...', data)
			const res = await api.post(`/facilities/assignDogs?date=${moment(date).format('YYYY-MM-DD')}&facilityId=${facility._id}`, { dogs: data })

			dispatch({ type: 'UPDATE_PLAYGROUPS_STATUS', payload: { facility_id: facility._id, playgroups: res.data } })
			dispatch(getVisitsByFacilityId(facility, date))
		} catch (e) {
			dispatch({ type: 'GET_VISITS_FAIL', payload: e })
			console.log('err...', e)
		}
	}

	const getStats = () => {
		return (
			<Grid container spacing={4}>
				<Grid item xs={3}>
					<StatBox
						label="Unassigned Dogs"
						number={unassigned_pets}
						dark
						showArrow
						onClick={() => goToUnassigned()}
					/>
				</Grid>
				<Grid item xs={3}>
					<StatBox label="Daytime dogs" number={daytime_pets} />
				</Grid>
				<Grid item xs={3}>
					<StatBox label="Needed groups" number={`${need_group_pets[0]}-${need_group_pets[1]}`} />
				</Grid>
				<Grid item xs={3}>
					<StatBox
						label="Active groups"
						number={active_groups}
						showAlert={active_groups < need_group_pets[0] || active_groups > need_group_pets[1]}
					/>
				</Grid>
			</Grid>
		)
	}

	const goToPlaygroup = (playgroup) => {
		setGroup(playgroup._id)
		history.push(
			`/facilities/${params.facilityId}/monitor/playgroup/${playgroup._id}?date=${moment(date).format(
				'YYYYMMDD'
			)}`
		)
	}

	const PlayStyle = ({ playStyle, openMenu, openMenus }) => {
		const [isExpanded, setIsExpanded] = useState(true)

		let typesInPlayStyle = playgroup_types
			.filter((p) => {
				if (!term) return true
				return p.name?.toLowerCase().includes(term.toLowerCase())
			})
			.filter((pt) => pt.play_style === playStyle)

		// sorting types in play style
		const sorted = []
		PLAYGROUP_TYPE_SIZES_ARRAY.forEach((size) => {
			const els = typesInPlayStyle.filter((t) => t.size === size)
			if (els.length) sorted.push(els)
		})
		typesInPlayStyle = sorted.flatMap((s) => s)

		const formatTitle = playStyle
			.split('-')
			.join(' ')
			.split(' ')
			.map((w) => capitalize(w))
			.join(' ')

		return (
			<div>
				<div className={classes.header}>
					<div>{formatTitle}</div>
					<div style={{ cursor: 'pointer', display: 'flex' }} onClick={() => setIsExpanded(!isExpanded)}>
						{isExpanded ? (
							<ExpandLessOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
						) : (
							<ExpandMoreOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
						)}
					</div>
				</div>

				<Collapse
					in={isExpanded}
					timeout="auto"
					unmountOnExit
					style={{ background: 'transparent', cursor: 'default' }}>
					{typesInPlayStyle.map((playgroupType, index) => {
						const playgroupsInType = playgroups.filter(
							(p) => playgroupType._id === p.playgroup_type_id
						)

						return (
							<PlaygroupTypeRow
								key={'PlaygroupTypeRow-' + index}
								type={playgroupType}
								playgroupsInType={playgroupsInType}
								visits={visits}
								areas={areas}
								kennels={kennels}
								kennel_blocks={kennel_blocks}
								setPlayShown={setPlayShown}
								setDialogShown={setDialogShown}
								setIsShown={setIsShown}
								pets={pets}
								openMenu={openMenu}
								openMenus={openMenus}
								loading={loading}
								goToPlaygroup={goToPlaygroup}
							/>
						)
					})}
				</Collapse>
			</div>
		)
	}



	const isLastDayOfVisit = (vis) => {
		// console.log("FORMATTED...", formattedDate);
		let index = vis.dates.findIndex((d) => d === formattedDate)
		if (index === vis.dates.length - 1) return true
		return false
	}

	const getGroupNum = (group) => {
		let dogsInGroup = 0
		if (!pets) return 0
		// console.log('visits...', visits)
		let numBestFit = 0
		visits.forEach((v, i) => {
			if (v.type === 'boarding') {
				if (!isLastDayOfVisit(v) || v.extended_pickup) {
					v.pets.forEach((p, i) => {
						if (p.best_fit_playgroup === group._id) numBestFit += 1
					})
				}
			} else {
				v.pets.forEach((p, i) => {
					if (p.best_fit_playgroup === group._id) numBestFit += 1
				})
			}
		})

		return numBestFit
	}

	const goToUnassigned = () => {
		return history.push(
			`/facilities/${facility._id}/monitor/unassigned?date=${moment(date).format('YYYYMMDD')}`
		)
	}

	return (
		<div className={classes.page}>
			<MuiThemeProvider theme={table}>
				<PlaygroupsToolbar
					date={date}
					setDate={setDate}
					changeDate={changeDate}
					allowAutoAssign={false}
					onSearchChange={(search) => setTerm(search)}
					canAssign={isBeforeTwoDays}
					autoAssign={autoAssign}
				/>
				<div className={classes.groupsBlocks}>
					<MaterialTable
						scheduleAggregates={props.scheduleAggregates}
						date={props.date}
						style={{ boxShadow: 'none', width: '100%' }}
						options={{
							headerStyle: {
								color: '#1A1A35',
								textTransform: 'uppercase',
								fontWeight: 800,
								fontSize: '12px',
								lineHeight: '16px',
								padding: '11px 24px',
								borderTop: '1px solid #D0CFD2',
								backgroundColor: '#F9F9F9'
							},
							paging: false,
							rowStyle: {
								verticalAlign: 'top',
								fontSize: 16
							},
							// pageSize: 20,
							// pageSizeOptions: [10, 20, 50],
							toolbarButtonAlignment: 'left',
							searchFieldAlignment: 'left',
							filtering: true
						}}
						columns={[]}
						data={props.playgroups}
						onRowClick={(e, addOn) => { }}
						components={{
							Cell: (props) => (
								<MTableCell
									style={{
										borderBottom: 'none',
										padding: '16px 36px 16px 24px'
									}}
									{...props}
								/>
							),
							Toolbar: (props) => (
								<div className={classes.toolbarWrapper}>
									<div className={classes.tables}>{getStats()}</div>
									{PLAY_STYLES_ARRAY.map((playStyle, i) => {
										return (
											<div key={'playStyle-' + i} className={classes.playStyles}>
												<PlayStyle
													playStyle={playStyle}
													key={`playstyle${i}`}
													openMenu={openMenu}
													openMenus={openMenus}></PlayStyle>
											</div>
										)
									})}
								</div>
							)
						}}
						title="Playgroups"
					/>
					{/* <div className={classes.bestFit}>
						<Typography variant="h4" className={classes.bestFitTitle}>
							Best Fit Playgroups
						</Typography>
						<div className={classes.timeBox}>{renderBestFitGroups()}</div>
					</div> */}
				</div>
			</MuiThemeProvider>
		</div>
	)
}

const PlaygroupTypeRow = ({
	type,
	playgroupsInType,
	visits,
	areas,
	setPlayShown,
	setDialogShown,
	setIsShown,
	pets,
	kennels,
	kennel_blocks,
	openMenus,
	openMenu,
	goToPlaygroup,
	loading
}) => {
	const classes = useStyles()
	const [isExpanded, setExpanded] = useState(false)

	const [unassignedBestFit, unassignedOtherFit] = (() => {
		const petIdsWithNoPlaygroup = []
		// console.info('length', visits.filter((v) => v.type === 'grooming').length)
		visits.forEach((v, i) => {
			if (v.pet_status && v.status && v.status.id !== 7) {
				v.pet_status.forEach((ps, i) => {
					if (!ps.playgroup) petIdsWithNoPlaygroup.push(ps.pet_id)
				})
			}
		})
		const mappedPets = petIdsWithNoPlaygroup
			.map((id) => {
				return pets.find((p) => p._id === id)
			})
			.filter(Boolean)

		const unPetsBestFit = mappedPets.filter((p) => p.best_fit_playgroup_type === type._id) // pets that have this playgroup type as their 'Best Fit'.
		const unPetsOtherFits = mappedPets.filter(
			(p) => p.alt_playgroup_type === type._id || p.other_playgroup_types?.includes(type._id)
		) // pets that have that playgroup type as their 'Alternate' or in their 'Flex' playgroup types.

		return [unPetsBestFit.length, unPetsOtherFits.length]
	})()

	const getActiveGroups = () => {
		return playgroupsInType.filter((p) => PLAYGROUP_MASKED_STATUS[p.status] === 'Activated').length
	}

	const getCapacity = () => {
		let cap = 0
		let dogsInGroup = 0
		for (const playgroup of playgroupsInType) {
			if (PLAYGROUP_MASKED_STATUS[playgroup.status] === 'Activated') {
				cap += playgroup.capacity ? playgroup.capacity : '?'
				visits.forEach((visit, i) => {
					if (visit.pet_status)
						visit.pet_status.forEach((pet, i) => {
							if (pet.playgroup == playgroup._id) dogsInGroup += 1
						})
				})
			}
		}

		return `${dogsInGroup}/${cap}`
	}

	const getSizes = () => {
		return PLAYGROUP_TYPE_BEST_FIT_SIZES_ARRAY.filter((size) =>
			type.best_fit_sizes.find((_size) => _size === size)
		)
			.map((size) => size.toUpperCase())
			.join(',')
	}

	const getAge = () => {
		return capitalize(type.age_category)
	}

	const filterActiveGroups = () => {
		return playgroupsInType.filter((g) => g.status === 'in use').sort((a, b) => b.name - a.name)
	}

	const filterInactiveGroups = () => {
		return playgroupsInType.filter((g) => g.status !== 'in use').sort((a, b) => b.name - a.name)
	}

	const combinedGroups = () => {
		const active = filterActiveGroups()
		const inactive = filterInactiveGroups()
		return [...active, ...inactive]
	}

	const sortedCombinedGroups = combinedGroups()

	return (
		<div className={classes.group}>
			<div className={classes.topRow}>
				<div className={classes.groupBodyCentered}>
					<div className={classes.groupColHorizontal} style={{ width: '16%' }}>
						<Typography
							variant="h5"
							onClick={() => {
								openMenu(type._id)
							}}
							style={{
								fontSize: '18px',
								fontWeight: 800,
								lineHeight: '25px',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								cursor: 'pointer'
							}}>
							{type.name}
						</Typography>
					</div>
					<div className={classes.groupColHorizontal} style={{ width: '16%' }}>
						<span className={classes.colLabel}>UNASSIGNED BEST FITS</span>
						<p className={classes.colValue}>{unassignedBestFit}</p>
					</div>
					<div className={classes.groupColHorizontal} style={{ width: '16%' }}>
						<span className={classes.colLabel}>UNASSIGNED OTHER FITS</span>
						<p className={classes.colValue}>{unassignedOtherFit}</p>
					</div>
					<div className={classes.groupColHorizontal} style={{ width: '11%' }}>
						<span className={classes.colLabel}>ACTIVE GROUPS</span>
						<p className={classes.colValue}>{getActiveGroups()}</p>
					</div>
					<div className={classes.groupColHorizontal} style={{ width: '14%' }}>
						<span className={classes.colLabel}>TOTAL CAPACITY</span>
						<p className={classes.colValue}>{getCapacity()}</p>
					</div>
					<CustomVerticalDivider width={'2%'} />
					<div className={classes.groupColHorizontal} style={{ width: '14%' }}>
						<span className={classes.colLabel}>SIZE</span>
						<p className={classes.colValue}>{getSizes()}</p>
					</div>
					<div className={classes.groupColHorizontal} style={{ width: '11%' }}>
						<span className={classes.colLabel}>AGE</span>
						<p className={classes.colValue}>{getAge()}</p>
					</div>
				</div>
				{/* <Icon className="fas fa-chevron-right" style={{ color: grey[500], fontSize: '18px' }} /> */}
				<div
					onClick={() => {
						openMenu(type._id)
					}}>
					{isExpanded ? (
						<ExpandLessOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					) : (
						<ExpandMoreOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					)}
				</div>
			</div>

			<Collapse
				in={openMenus.includes(type._id)}
				timeout="auto"
				unmountOnExit
				style={{ background: 'transparent' }}>
				{sortedCombinedGroups.map((playgroup, index) => {
					return (
						<PlaygroupRow
							loading={loading}
							key={`PlaygroupRow${index}`}
							playgroup={playgroup}
							playgroupType={type}
							playgroupsInType={sortedCombinedGroups}
							visits={visits}
							kennels={kennels}
							kennel_blocks={kennel_blocks}
							setPlayShown={setPlayShown}
							setDialogShown={setDialogShown}
							setIsShown={setIsShown}
							areas={areas}
							pets={pets}
							showDivider={index < playgroupsInType.length - 1}
							goToPlaygroup={goToPlaygroup}
						/>
					)
				})}
			</Collapse>
		</div>
	)
}

const PlaygroupRow = ({
	playgroupsInType,
	playgroupType,
	playgroup,
	visits,
	areas,
	pets,
	showDivider = true,
	kennels,
	kennel_blocks,
	setPlayShown,
	setDialogShown,
	setIsShown,
	goToPlaygroup,
	loading
}) => {
	const [anchorEl, setAnchorEl] = useState(null)
	const dispatch = useDispatch()
	const [deactivateModal, setDeactivateModal] = useState(false)

	const open = Boolean(anchorEl)
	const maskedStatus = PLAYGROUP_MASKED_STATUS[playgroup.status] || 'Unassigned'
	const isDeactivated = maskedStatus === 'Deactivated'
	const deactivatedColor = { color: isDeactivated ? '#777679' : undefined }
	const facility = useSelector((state) => state.specific.facilities.selected)
	const classes = useStyles({ isDeactivated, deactivatedColor })

	const handleOpenMenu = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleCloseMenu = () => {
		setAnchorEl(null)
	}

	const getCapacity = () => {
		let cap = playgroup.capacity ? playgroup.capacity : '?'
		let dogsInGroup = 0
		visits.forEach((visit, i) => {
			if (visit.pet_status)
				visit.pet_status.forEach((pet, i) => {
					if (pet.playgroup == playgroup._id) dogsInGroup += 1
				})
		})

		return `${dogsInGroup} / ${cap}`
	}

	const getInFacility = () => {
		let dogsInGroup = 0
		visits.forEach((visit, i) => {
			if (visit.pet_status)
				visit.pet_status.forEach((pet, i) => {
					if (pet.playgroup == playgroup._id && pet.checked_in) dogsInGroup += 1
				})
		})

		return `${dogsInGroup} in facility`
	}

	const [playAreaName, hasPlayArea] = (() => {
		const { indoor, outdoor, kennelRooms } = getSpecificAreas({ areas })
		const a = indoor.find((a) => a._id === playgroup.area_id)
		const b = outdoor.find((a) => a._id === playgroup.area_id)
		const c = areas.find((a) => a._id === playgroup.area_id)
		const found = a || b || c

		return found ? [found.name, true] : ['No Assignment', false]
	})()

	const [kennelBlocks, hasKennelBlocks] = (() => {
		// this finds the kennels currently assigned to the group, regardless of the actual assigned block
		// we then show the blocks that those kennels belong to. If all of the kennels in a block are assigned to the group,
		// just show the name. Otherwise, we add the (partial) field.
		// we then add any kennels that don't have a block, but are also assigned
		let blocks = [
			...new Set(
				kennels
					.filter(
						(k) => k.playgroup_id === playgroup._id && k.kennel_block_id && k.status !== 'disabled'
					)
					.map((k) => k.kennel_block_id)
			)
		]
			.map((id) => kennel_blocks.find((kb) => kb._id === id))
			.filter(Boolean)

		if (!blocks.length) return ['No Assignment', false]
		let str = ``
		let kennelsWithoutBlocks = kennels.filter(
			(k) => k.status !== 'disabled' && k.playgroup_id === playgroup._id && !k.kennel_block_id
		)

		blocks.forEach((block, i) => {
			const kennelsInBlock = kennels.filter(
				(kib) => kib.status !== 'disabled' && kib.kennel_block_id && kib.kennel_block_id === block._id
			)
			const partial =
				kennelsInBlock.length && !kennelsInBlock.every((kib) => kib.playgroup_id === playgroup._id)
			let toAdd = ``
			if (partial) {
				toAdd += `${block.name} (Partial)`
			} else {
				toAdd += `${block.name}`
			}

			if (i < blocks.length - 1 || kennelsWithoutBlocks.length) toAdd += ', '
			str += toAdd
		})

		kennelsWithoutBlocks.forEach((k, i) => {
			let toAdd = k.reference_number
			if (i < kennelsWithoutBlocks.length - 1) toAdd += ', '
			str += toAdd
		})

		// console.log('blocks....', blocks)
		return [str, !!str]
	})()

	const getKennels = () => {
		let str = ``

		const playgroupKennels = playgroup.kennels || [] // this is a list of reference numbers
		const ourKens = kennels.filter((k) => playgroupKennels.includes(k.reference_number))

		const fullBlocks = []
		const partialBlocks = []
		for (const block of kennel_blocks) {
			const kennelsInBlock = kennels.filter((k) => k.kennel_block_id === block._id)
			if (!kennelsInBlock.length) continue

			if (kennelsInBlock.every((k) => playgroupKennels.includes(k.reference_number))) {
				fullBlocks.push(block.name)
			} else if (kennelsInBlock.some((k) => playgroupKennels.includes(k.reference_number))) {
				partialBlocks.push(block.name + ' (Partial)')
			}
		}

		fullBlocks.push(...partialBlocks)
		if (fullBlocks.length) {
			str = fullBlocks.join(',')
		}

		return str || 'No Assignment'
	}

	const getPets = () => {
		let pet_ids = []
		visits.forEach((visit, i) => {
			visit.pet_status.forEach((status, i) => {
				if (status.playgroup === playgroup._id) pet_ids.push(status.pet_id)
			})
		})

		return pet_ids.map((id) => pets.find((p) => p._id === id))
	}

	const getCharacteristics = () => {
		let groupPets = getPets()
		const characteristics = {
			play_style: [],
			energy_level: [],
			size: [],
			age: []
		}

		return (
			<div className={classes.characteristics}>
				<div style={{ width: '50%', marginRight: '10px' }}>
					<div className={classes.playBlock}>
						<span className={classes.playName}>Style</span>
						<span className={classes.kennelBlock}>
							{/* {characteristics.play_style.filter((v) => v).join(', ') || DEFAULT_EMPTY_VALUE} */}
							{/* {playgroup?.play_style || DEFAULT_EMPTY_VALUE} */}
							{capitilizeMultipleWords(playgroupType?.play_style) || DEFAULT_EMPTY_VALUE}
						</span>
					</div>
					<div className={classes.playBlock}>
						<span className={classes.playName}>Size</span>
						<span className={classes.kennelBlock}>
							{/* {characteristics.size.filter((v) => v).join(', ') || DEFAULT_EMPTY_VALUE} */}
							{/* {playgroup?.sizes?.map((j) => j.toUpperCase()).join(', ') || DEFAULT_EMPTY_VALUE} */}
							{playgroupType?.best_fit_sizes?.map((j) => j.toUpperCase()).join(', ') ||
								DEFAULT_EMPTY_VALUE}
						</span>
					</div>
				</div>
				<div className={classes.playBlock} style={{ width: '50%' }}>
					<span className={classes.playName}>Age</span>
					<span className={classes.kennelBlock}>
						{/* {characteristics.age.filter((v) => v).join(', ') || DEFAULT_EMPTY_VALUE} */}
						{/* {playgroup?.ages?.map((j) => j.toUpperCase()).join(', ') || DEFAULT_EMPTY_VALUE} */}
						{capitalize(playgroupType?.age_category) || DEFAULT_EMPTY_VALUE}
					</span>
				</div>
			</div>
		)
	}

	const getOutliers = () => {
		if (!playgroupType?._id) return null

		const dogs = []
		const outliers = []
		visits.forEach((visit, i) => {
			if (visit.pet_status)
				visit.pet_status.forEach((pet, i) => {
					if (pet.playgroup == playgroup._id) dogs.push(pet)
				})
		})

		dogs.map((dog) => {
			let wholeDog = pets.find((p) => p._id === dog.pet_id)
			return wholeDog
		})
			.filter(Boolean)
			.forEach((dog, i) => {
				let size = getPetSizeV1(dog)

				let age = dog.birthday ? getPetAge(dog.birthday) : null
				age = age ? age.toLowerCase() : ''

				if (
					size &&
					playgroupType.best_fit_sizes &&
					!playgroupType.best_fit_sizes.includes(size) &&
					!playgroupType.best_fit_sizes.includes('all')
				)
					outliers.push(size.toUpperCase())
				if (dog.play_style && playgroupType.play_style && playgroupType.play_style !== dog.play_style)
					outliers.push(dog.play_style)
				if (
					playgroupType.age_category &&
					playgroupType.age_category.toLowerCase() !== 'all' &&
					age &&
					!playgroupType.age_category !== age
				)
					outliers.push(age)
			})

		const outs = [...new Set(outliers)]

		const text = outs.length ? outs.map((w) => capitilizeMultipleWords(w)).join(', ') : DEFAULT_EMPTY_VALUE

		return (
			<div className={classes.playBlock}>
				<Typography
					style={{
						// marginRight: 12,
						// marginBottom: 6,
						color: outliers.length ? '#DB4A42' : '#777679',
						fontSize: '14px',
						fontWeight: '600',
						lineHeight: '19px'
					}}>
					{text}
				</Typography>
			</div>
		)
	}

	const getStatusColor = () => {
		if (playgroup.status === 'in use') {
			return 'green'
		} else {
			return 'red'
		}
	}

	const changePlayArea = (group) => {
		setPlayShown(true, group)
	}

	const changeStaff = (group) => {
		setIsShown(true, group)
	}

	const changeKennels = (group) => {
		setDialogShown(true, group)
	}

	const handleActivateForToday = () => {
		dispatch({ type: 'UPDATE_FACILITY' })
		handleCloseMenu()
		setDeactivateModal(true)
		const status = playgroup.status === 'overflow' ? 'in use' : 'overflow'

		// move the pets to 'unassigned', if we are deactivating the group
		if (status === 'overflow') {
			const ourPets = getPets()
			const ourVisits = []
			const pet_ids = ourPets.map((p) => p._id)
			const stati = [1, 2, 3, 4, 5]
			visits.forEach((v) => {
				if (v.pet_status) {
					v.pet_status.forEach((stat, i) => {
						if (stat.playgroup === playgroup._id) ourVisits.push(v._id)
					})
				}
			})

			const payload = {
				pet_ids,
				playgroup: null,
				visit_ids: ourVisits
			}
			if (pet_ids?.length && ourVisits?.length) dispatch(movePets(payload))
		}

		const playgroups = facility.playgroups.map((g) => {
			let area_id
			if (g._id === playgroup._id) {
				if (status === 'overflow') {
					area_id = null
				} else {
					area_id = g.default_indoor_play_area_id
				}
			} else {
				area_id = g.area_id
			}
			return {
				...g,
				status: g._id === playgroup._id ? status : g.status,
				area_id
			}
		})

		let _kennels
		// we are deactivating the group, so we will unassign any kennels that
		// it currently has assigned
		if (status === 'overflow') {
			_kennels = kennels.map((k) => {
				return {
					...k,
					playgroup_id: k.playgroup_id === playgroup._id ? null : k.playgroup_id
				}
			})
		} else {
			// we are activating the group, so go find any kennels that are in its default kennel block
			// and assign those to the group (unless they are assigned elsewhere)
			_kennels = facility.kennels.map((k) => {
				return {
					...k,
					playgroup_id:
						playgroup.kennel_block_id &&
							k.kennel_block_id === playgroup.kennel_block_id &&
							!k.playgroup_id
							? playgroup._id
							: k.playgroup_id
				}
			})
		}

		const fac = {
			_id: facility._id,
			playgroups,
			kennels: _kennels
		}
		dispatch(updateFacilityIndividual(facility._id, fac))
		setDeactivateModal(false)

	}

	const getModalText = () => {
		const petsInPlaygroup = getPets()
		if (playgroup.status === 'overflow') {
			// we are activating the group, so use these...
			if (playgroup.default_status === 'in use')
				return 'Are you sure you want to activate this group? It will remain active until manually deactivated.'
			return 'Are you sure you want to activate this group? It will remain active for today, but will deactivate tomorrow morning if there are no dogs in the group'
		} else {
			// we are deactivating
			if (playgroup.default_status === 'in use') {
				if (petsInPlaygroup && petsInPlaygroup.length)
					return `Are you sure you want to deactivate this playgroup for today? There ${petsInPlaygroup.length > 1 ? 'are' : 'is'
						} ${petsInPlaygroup.length} dog${petsInPlaygroup.length > 1 ? 's' : ''
						} assigned to this group. If deactivated, they will be moved to Unassigned Dogs.`
				return 'Are you sure you want to deactivate this playgroup for today? It will only remain deactivated for the day, and then reactivate tomorrow morning.'
			} else {
				if (petsInPlaygroup && petsInPlaygroup.length)
					return `Are you sure you want to deactivate this playgroup? There ${petsInPlaygroup.length > 1 ? 'are' : 'is'
						} ${petsInPlaygroup.length} dog${petsInPlaygroup.length > 1 ? 's' : ''
						} assigned to this group. If deactivated, they will be moved to Unassigned Dogs.`
				return 'Are you sure you want to deactivate this playgroup? It will remain deactivated until manually re-activated.'
			}
		}
	}

	const getAssignedDogs = () => {
		const petsInPlaygroup = getPets()
		if (petsInPlaygroup && petsInPlaygroup.length)
			return (
				<div className={classes.unassignedBox}>
					{petsInPlaygroup.map((p) => {
						let visit = visits.find((v) => v.pet_ids?.includes(p._id))
						let last_name =
							visit?.household?.accounts?.find((a) => a.primary || a.last_name)?.last_name || ''
						return (
							<Typography
								variant="body1"
								style={{ marginLeft: 28, marginTop: 16, fontSize: 16, fontWeight: '600' }}>
								{p.name} {last_name}
							</Typography>
						)
					})}
				</div>
			)

		return null
	}

	return (
		<div>
			<div className={classes.innerGroup}>
				{' '}
				{/* style={{ opacity: isDeactivated ? 0.5 : 1 }} */}
				<div className={classes.topRow}>
					<div className={classes.groupCol} style={{ width: '13.5%', paddingLeft: 0 }}>
						<div style={{ cursor: 'pointer' }} onClick={() => goToPlaygroup(playgroup)}>
							<Typography
								style={{
									fontFamily: 'Nunito',
									fontStyle: 'normal',
									fontSize: '20px',
									fontWeight: '800',
									lineHeight: '27px'
								}}>
								{playgroup.name}
							</Typography>
						</div>
						<Box display="flex" flexDirection="row" alignItems="center" mt="5px">
							<Box className={classes.dot} style={{ backgroundColor: getStatusColor() }}></Box>
							<Typography
								style={{
									fontFamily: 'Nunito',
									fontStyle: 'normal',
									fontSize: '14px',
									fontWeight: 'bold',
									lineHeight: '19px',
									color: getStatusColor()
								}}>
								{maskedStatus}
							</Typography>
						</Box>
					</div>
					<div className={classes.groupBody}>
						<div className={classes.groupCol} style={{ width: '10%' }}>
							<span className={classes.colTitle}>CAPACITY</span>
							<p className={classes.capacity}>{getCapacity()}</p>
							<p
								style={{
									fontSize: '14px',
									lineHeight: '19px',
									fontWeight: '600',
									margin: 0,
									color: '#777679'
								}}>
								{getInFacility()}
							</p>
						</div>
						<CustomVerticalDivider />
						<div className={classes.groupCol} style={{ width: '30%' }}>
							<span className={classes.colTitle}>
								ASSIGNMENTS {` `}
								{(!hasPlayArea || !hasKennelBlocks) && playgroup.status === 'in use' && (
									<i className="fas fa-exclamation-circle" />
								)}
							</span>
							<div className={classes.playBlock}>
								<span className={classes.playName}>Play</span>
								<span
									className={classes.kennelBlock}
									style={{
										maxWidth: '144px',
										color: !hasPlayArea && !isDeactivated ? '#DB4A42' : undefined
									}}>
									{playAreaName}
								</span>
								<span
									className={classes.change}
									onClick={() => !isDeactivated && changePlayArea(playgroup)}>
									Change
								</span>
							</div>

							<div className={classes.playBlock}>
								<span className={classes.playName}>Rest</span>
								<span
									className={classes.kennelBlock}
									style={{
										maxWidth: '144px',
										color: !hasKennelBlocks && !isDeactivated ? '#DB4A42' : undefined,
										whiteSpace: 'initial',
										wordWrap: 'break-word'
									}}>
									{kennelBlocks}
								</span>
								<span
									className={classes.change}
									onClick={() => !isDeactivated && changeKennels(playgroup)}>
									Change
								</span>
							</div>
						</div>
						<CustomVerticalDivider />
						<div className={classes.groupCol} style={{ width: '30%' }}>
							<span className={classes.colTitle}>CHARACTERISTICS</span>
							{getCharacteristics()}
						</div>
						<CustomVerticalDivider />
						<div className={classes.groupCol} style={{ width: '20%' }}>
							<span className={classes.colTitle}>OUTLIERS</span>
							{getOutliers()}
						</div>
						<div className={classes.groupCol} style={{ width: '5%' }}>
							<IconButton
								aria-label="more"
								id="long-button"
								aria-controls="long-menu"
								aria-expanded={open ? 'true' : undefined}
								aria-haspopup="true"
								onClick={handleOpenMenu}>
								<MoreVertIcon />
							</IconButton>
							<Menu
								id="basic-menu"
								anchorEl={anchorEl}
								open={open}
								onClose={handleCloseMenu}
								MenuListProps={{
									'aria-labelledby': 'basic-button'
								}}>
								<MenuItem
									onClick={() => {
										goToPlaygroup(playgroup)
									}}>
									View playgroup
								</MenuItem>
								<MenuItem onClick={() => setDeactivateModal(true)} style={{ color: '#DB4A42' }}>
									{playgroup.status === 'overflow' ? 'Activate' : 'Deactivate'} Playgroup For
									Today
								</MenuItem>
							</Menu>
						</div>
					</div>
				</div>
			</div>
			{showDivider && <CustomHorizontalDivider />}
			<DeleteConfirmation
				isShown={deactivateModal}
				setIsShown={() => setDeactivateModal(false)}
				onConfirmDelete={handleActivateForToday}
				isDeleteLoading={loading}
				confirmButtonText={isDeactivated ? 'Activate' : 'Deactivate'}
				// title={isDeactivated ? 'Activate Playgroup' : 'Deactivate Playgroup'}
				title={
					<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
						<Typography
							style={{
								color: '#1A1A35',
								fontSize: '16px',
								fontWeight: '800',
								lineHeight: '22px',
								marginRight: 17
							}}>
							{isDeactivated ? 'Activate Playgroup' : 'Deactivate Playgroup'}
						</Typography>
						<Typography
							style={{
								color: '#5F38BE',
								fontSize: '12px',
								fontWeight: '800',
								lineHeight: '16px',
								textTransform: 'uppercase'
							}}>
							{playgroup?.name}
						</Typography>
					</div>
				}
				body={getModalText()}>
				{getAssignedDogs()}
			</DeleteConfirmation>
		</div>
	)
}

const CustomVerticalDivider = ({ width }) => {
	const classes = useStyles()
	return (
		<div
			className={classes.columnNoWidth}
			style={{
				width: width ?? '2.5%'
			}}>
			<Divider orientation="vertical" style={{ background: '#D0CFD2', width: 1, height: 45 }} />
		</div>
	)
}

const CustomHorizontalDivider = ({ width }) => {
	const classes = useStyles()
	return (
		<div
			style={{
				// paddingTop: '33px',
				width: width ?? '100%%'
			}}>
			<Divider orientation="horizontal" style={{ background: '#D0CFD2', width: '100%' }} />
		</div>
	)
}
